import { createStorageService } from './create-storage-service';

export const sessionStorageService = (key: string) =>
  createStorageService(key, window.sessionStorage);
